module.exports = __webpack_public_path__ + "static/resources-list-snapshot-menu-8ce173097156abfd012fd171eb5b57b1.png";